angular.module 'zc.projects'

.directive 'zcAggregateType', ->
  directive =
    restrict: 'E'
    scope: {
      campaign: '='
    }
    template: """
<div class="aggregate_type_new" ng-if="campaign.aggregate_type == 'new'">NEW</div>
<div class="aggregate_type_repeat" ng-if="campaign.aggregate_type == 'repeat'">REPEAT</div>
<div class="aggregate_type_spot" ng-if="campaign.aggregate_type == 'spot'">SPOT</div>
    """

    link: (scope, element, attrs) ->

  directive



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/zc_aggregate_type.directive.coffee